import { observer } from 'mobx-react';
import { useCallback, useMemo } from 'react';
import moment from 'moment';
import { useCheckoutStoreContext } from '../../context';
import { getProductErrorMessage } from '../../helpers/checkout';
import { OrderCartProductErrorMessage } from '../OrderCartProductErrorMessage/OrderCartProductErrorMessage';
import { OrderCartProductExclusions } from '../OrderCartProductExclusions/OrderCartProductExclusions';
import { OrderCartProductFooter } from '../OrderCartProductFooter/OrderCartProductFooter';
import { OrderCartProductHeader } from '../OrderCartProductHeader/OrderCartProductHeader';
import { OrderCartProductItems } from '../OrderCartProductItems/OrderCartProductItems';
import { OrderCartProductModifiers } from '../OrderCartProductModifiers/OrderCartProductModifiers';
import { OrderCartProductUnit } from '../OrderCartProductUnit/OrderCartProductUnit';
import { IMenuProduct } from 'src/types/products';
import { modalStore } from 'src/mobx/modalStore';
import { DELIVERY_TYPE } from '~/constants/deliveryTypes';
import './style.scss';

interface IProps {
  product: IMenuProduct;
}

const OrderCartProduct: React.FC<IProps> = observer(({ product }: IProps): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const productError = useMemo((): string => {
    return getProductErrorMessage(product, checkoutStore.supportedProductOrderType);
  }, [product, checkoutStore.supportedProductOrderType]);

  const onProductSelect = useCallback(() => {
    modalStore.openOrderProduct({
      id: product.id,
      product,
      branch: checkoutStore.dependencies.branch,
      onSubmit: checkoutStore.updateProduct,
      error: product.error,
      isEdit: true,
      isDraft: checkoutStore.isDraft,
      time: checkoutStore.params.preorder && checkoutStore.params.preorder_date ? moment(checkoutStore.params.preorder_date).unix() : undefined,
      orderType: checkoutStore.params.is_dinein ? DELIVERY_TYPE.DINE_IN : (checkoutStore.params.delivery_type as DELIVERY_TYPE),
    });
  }, [product]);

  return (
    <div className="order-cart-product" onClick={onProductSelect}>
      <OrderCartProductHeader product={product} />
      <OrderCartProductUnit product={product} />

      <div className="d-flex flex-column">
        <OrderCartProductModifiers modifiers={product.modifiers} />
        <OrderCartProductExclusions exclusions={product.exclusions} />
        <OrderCartProductItems product={product} />
      </div>

      <OrderCartProductFooter product={product} productError={productError} />
      <OrderCartProductErrorMessage productError={productError} />
    </div>
  );
});

export default OrderCartProduct;
